import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const BulkProgramSearchParticipantsWrapper = styled.div`
  .search-button-container {
    margin: 32px 16px 16px 20px;
    text-align: end;
    ${responsive.MOBILE`
      margin: 32px 8px 16px 8px;    
      
      button {
        width: 100%;
      }
    `}
  }

  .search-header-container {
    display: flex;
    justify-content: space-between;

    .reset-all-button {
      padding: 0px 10px;
      height: 40px;

      svg {
        margin-right: 8px;
      }
    }
  }

  .form-container {
    padding: 0px 0px 16px 16px;
    ${responsive.MOBILE`
        padding: 0px 8px;
      `}
  }

  .accordion-header:not(:first-of-type) {
    margin-top: 24px;
    ${responsive.MOBILE`
      margin-top: 16px;

      .MuiPaper-root {
        background-color: transparent;
      
        .MuiCollapse-root {
          margin-top: 8px;

          .MuiAccordionDetails-root > div > div:nth-of-type(2) {
            margin-top: 8px;
            background-color: ${COLORS.cirrus_white};
          }
        }
      }
    `}
  }

  .accordion-header:last-child {
    margin-bottom: 32px;
  }

  .form-header {
    padding-left: 16px;
    display: flex;
    justify-content: space-between;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
      .title-container {
        display: flex;
        align-items: center;

        .selected-count {
          color: ${COLORS.cirrus_white};
          background-color: ${COLORS.cirrus_black7};
          padding: 2px 9px 4px 9px;
          border-radius: 7px;
          margin-left: 8px;
        }
      }
    }
  }
  .semi-header {
    display: flex;
    padding: 16px 16px 16px 16px;
    justify-content: flex-end;
  }
`;

export const SearchParticipantsResultWrapper = styled.div`
  .cell {
    min-width: 200px;
  }

  .MuiCheckbox-root {
    padding: 0px;
  }

  .search-result-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;

    ${responsive.MOBILE`
      background-color: ${COLORS.cirrus_white};
      align-self: flex-start;
      flex-direction: column;
      .search-header-right {
        align-self: flex-start;
        padding-top: 16px;
        width: 100%;
      }
      .search-header-right > * {
        flex: 1;           
      }
      .search-result-header {
        align-self: flex-start;
      }
    `}
  }

  .search-header-right {
    display: flex;
    justify-content: space-between;
  }
  .search-result-header {
    color: ${COLORS.cirrus_black10};
  }
`;
